import React, { useEffect, useRef, useState } from 'react';
import { subscribeScannerSession } from './scannerSession';
import './ScannerFeedbackOverlay.css';

const ScannerFeedbackOverlay = () => {
    const [flash, setFlash] = useState(null);
    const timerRef = useRef(0);

    useEffect(() => {
        return subscribeScannerSession((event) => {
            if (event.type !== 'result' || !event.flash) return;
            window.clearTimeout(timerRef.current);
            setFlash(event.flash);
            timerRef.current = window.setTimeout(() => {
                setFlash(null);
            }, event.flashMs || 500);
        });
    }, []);

    useEffect(
        () => () => {
            window.clearTimeout(timerRef.current);
        },
        []
    );

    if (!flash) return null;

    return (
        <div
            className={`scanner-feedback-overlay scanner-feedback-overlay--${flash}`}
            aria-hidden="true"
        />
    );
};

export default ScannerFeedbackOverlay;
